import React from "react"
import { segmentAvailableNow } from "../../helpers/allocationAvailability"

const AllocationAvailabilitySummary = ({ segment, totalStock }) => {
  const availableNow = segmentAvailableNow(segment, totalStock)
  if (availableNow === null) return null

  return (
    <div
      className="text-reg-11 text-[#555] mt-1"
      data-testid="segment-availability"
    >
      Available now: <strong>{availableNow}</strong>
    </div>
  )
}

export default AllocationAvailabilitySummary
